//THOUGHT MUTATIONS
export const SET_THOUGHT = "SET_THOUGHT"
export const RESET_THOUGHT = "RESET_THOUGHT"
export const RESET_THOUGHTS = "RESET_THOUGHTS"
export const SET_CHECKIN_THOUGHT_LOADING = "SET_CHECKIN_THOUGHT_LOADING"
export const PUSH_THOUGHT = "PUSH_THOUGHT"